export const officeData = [
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard1.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard2.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard3.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard4.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard5.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard6.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard1.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard2.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard3.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard4.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard5.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard6.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard1.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard2.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard3.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard4.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard5.png",
        area : 120,
    },
    {
        title: "Berlin, 101124",
        price : "12.000 €",
        numberOfOffices : 3,
        image: "images/officeCards/officeCard6.png",
        area : 120,
    }
]